export default {
  // Example:
  // let a = {user: {customer: { name: "Foo" }}}
  // find(a, "user.customer.name")
  // => "Foo"
  find(object, nestedPropertyName) {
    let parts = nestedPropertyName.split(".")
    let length = parts.length
    let property = object

    for ( let i = 0; i < length; i++ ) {
      if (parts[i] && parts[i].slice(-1) == "]") {
        let regexResult = parts[i].match(/(\w+)\[(\d+)\]/)
        let arrayKey = regexResult[1]
        let arrayIndex = regexResult[2]

        if (Array.isArray(property[arrayKey])) {
          property = property[arrayKey][arrayIndex]
        }
      } else if (!property || !property[parts[i]]) {
        return null
      } else {
        property = property[parts[i]];
      }
    }
    return property
  },

  // Example:
  // let a = {}
  // apply(a, "user.customer.name", "Foo")
  // => a == {user: {customer: { name: "Foo" }}}
  apply(object, nestedPropertyName, value) {
    let parts = nestedPropertyName.split(".")
    let length = parts.length
    let target = object

    for ( let i = 0; i < length; i++ ) {
      if (i == length - 1) {
        if (parts[i].slice(-2) == "[]") {
          let key = parts[i].slice(0, -2)
          if (!target[key]) {
            target[key] = []
          }
          target[key].push(value)
        } else {
          target[parts[i]] = value
        }
        return object
      }
      if (!target[parts[i]]) {
        target[parts[i]] = {}
      }
      target = target[parts[i]]
    }
  },

  build(flatObject) {
    let params = {}
    for (let [nestedPropertyName, value] of Object.entries(flatObject)) {
      this.apply(params, nestedPropertyName, value)
    }
    return params
  }
}